import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";

interface MealDescriptionProps {
  description?: string;
}

export const MealDescription = memo(function MealDescription({
  description,
}: MealDescriptionProps) {
  console.log("description", description);
  if (!description) {
    return null;
  }
  return <p className={cn(textVariants.body, "text-center")}>{description}</p>;
});
